import { IS_MINIPROGRAM, IS_WEIXIN, siteConfig } from '../config'
import { axios } from '../plugins/axios'
import { base } from '../router/index'

const {allow_miniprogram_geolocation = false} = siteConfig

let configVersion = 0

const wxConfig = (_vueRoute) => {
  const version = ++configVersion
  window._wxConfigLoaded = false
  window._wxConfigError = null
  if (window.forbidWeixinConfig) {
    return
  }
  // 首先判断是否为微信浏览器环境
  if (!IS_WEIXIN) {
    return
  }
  if (IS_MINIPROGRAM && !allow_miniprogram_geolocation) {
    return
  }
  if (process.env.NODE_ENV !== 'production') {
    return
  }
  const onError = (error) => {
    if (version !== configVersion) return
    window._wxConfigLoaded = false
    window._wxConfigError = error
    console.error('微信 JS-SDK 配置失败:', error)
    window.eventBus.$emit('wxConfigError', error)
  }
  axios
    .get('', {
      params: {
        act: 'hapi',
        op: 'weixin'
      },
      headers: {
        currURI: (window.location.origin + base + _vueRoute.fullPath.slice(1)).split('#')[0]
      },
      showMessage: false
    })
    .then((res) => {
      if (version !== configVersion) return
      const datas = (res && res.datas)
      const { wx, eventBus } = window
      if (!wx || !datas || !datas.appId || !datas.signature || !datas.nonceStr || !datas.timestamp) {
        throw new Error('微信 JS-SDK 或签名配置缺失')
      }
      wx.error(onError)
      wx.config({
        ...datas,
        jsApiList: [
          'hideAllNonBaseMenuItem',
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'showMenuItems',
          'openLocation',
          'getLocation'
        ],
        openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app']
      })
      wx.ready(function () {
        if (version !== configVersion || window._wxConfigError) return
        window._wxConfigLoaded = true
        eventBus.$emit('wxReady')
        wx.hideAllNonBaseMenuItem()
      })
    })
    .catch(onError)
}

export { wxConfig }
